

export default function renderStringOrComponent(stringOrComponent, props) {
    return (typeof stringOrComponent === "function" && stringOrComponent(props)) || stringOrComponent || '';
}
